// CategoryDetails.tsx
import React from 'react';
import { formatCurrency, formatPercent, formatNumber } from '../utils';
import './CategoryDetails.scss';
import {
  toCurrency,
  toPercent_2,
  toPercentRounded,
} from '../../../utils/numbers';

interface CategoryDetailsProps {
  // category: Category;
  onBack: () => void;
}

const CategoryDetails: React.FC<CategoryDetailsProps> = ({
  category,
  onBack,
}) => {
  const formatMetricValue = (value: number, metric: string): string => {
    switch (metric) {
      case 'cpa':
      case 'cpc':
      case 'cpm':
        return toCurrency(value);
      case 'ctr':
        return toPercent_2(value);
      default:
        return formatNumber(value);
    }
  };

  return (
    <div className="category-details show">
      <div className="category-details__back">
        <button onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div>
        <div className="subheader subheader--sm">{category.name}</div>

        <table className="table table-borderless category-table">
          <thead>
            <tr className="category-table__header">
              <th className="category-table__cell header">Label</th>
              <th className="category-table__cell header">CPA</th>
              <th className="category-table__cell header">% Spend</th>
            </tr>
          </thead>
          <tbody>
            {category.labels.map((label, index) => {
              const ranking = ('00' + (index + 1)).slice(-2);

              return (
                <tr
                  key={label.name}
                  className={`category-table__row ${
                    label.isActive ? 'category-table__row--active' : ''
                  }`}
                >
                  <td className="category-table__cell label">
                    <div className="item-number">
                      <span>{ranking}</span>
                    </div>
                    <div className="label-name">
                      <span>{label.name}</span>
                    </div>
                  </td>
                  <td className="category-table__cell">
                    {formatMetricValue(label.performance.cpa, 'cpa')}
                  </td>
                  <td className="category-table__cell">
                    {toPercentRounded(label.performance.percentSpend) ?? '-'}
                    {/* {formatCurrency(label.performance.total_spend)} */}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CategoryDetails;
